import { render, staticRenderFns } from "./InfoGraphicsImagePreview.vue?vue&type=template&id=32d1f81a"
import script from "./InfoGraphicsImagePreview.vue?vue&type=script&lang=js"
export * from "./InfoGraphicsImagePreview.vue?vue&type=script&lang=js"
import style0 from "./InfoGraphicsImagePreview.vue?vue&type=style&index=0&id=32d1f81a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports